import EditTable from './EditTable';
export default EditTable;
//# sourceMappingURL=index.js.map
